import {
  ShopperAgentOutreachOrigin,
  type ShopperAgentOutreachOrigin as ShopperAgentOutreachOriginType,
} from "./outreach-origin";

export const ShopperAgentAutomationKind = {
  Recover: "recover",
  Sms: "sms",
  ShopperAgent: "shopper_agent",
} as const;

export type ShopperAgentAutomationKind =
  (typeof ShopperAgentAutomationKind)[keyof typeof ShopperAgentAutomationKind];

/** Only when origin is automation. Explicit kind wins; recover config implies Recover; else SMS. */
export function classifyShopperAgentAutomationKind(input: {
  readonly origin: ShopperAgentOutreachOriginType;
  readonly recoverConfigId?: string | null;
  readonly automationKind?: ShopperAgentAutomationKind | null;
}): ShopperAgentAutomationKind | null {
  if (input.origin !== ShopperAgentOutreachOrigin.Automation) {
    return null;
  }
  if (input.automationKind) {
    return input.automationKind;
  }
  if (input.recoverConfigId) {
    return ShopperAgentAutomationKind.Recover;
  }
  return ShopperAgentAutomationKind.Sms;
}
